import { render } from "./HousingNewUnit.vue?vue&type=template&id=ce96e6c4"
import script from "./HousingNewUnit.vue?vue&type=script&lang=js"
export * from "./HousingNewUnit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__